import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import UserProfileSettingComp from "../../../components/userProfileComp/UserProfileSettingListComp";

export const UserProfilePage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar displayType="title" title="Account Settings" showNotification></TopBar>
        <UserProfileSettingComp></UserProfileSettingComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserProfilePage;
